
export const initDialogData = {
  AccCd: "",
  FName: "",
  LName: "",
  NName: "",
  Email: "",
  Tel: "",
  AccSts: 1,
  SendEmail: 1,
}